// src/components/admin/AboutEditor.js
import React, { useState, useEffect } from 'react';
import './EditorStyles.css';

const AboutEditor = () => {
  const [aboutData, setAboutData] = useState({
    title: "About Us",
    subtitle: "Learn more about our company",
    mainContent: "Lorem ipsum dolor sit amet, consectetur adipiscing elit...",
    imageUrl: "/path/to/image.jpg"
  });
  
  // In a real app, you would fetch this data from your backend or storage
  useEffect(() => {
    // Mock API call
    // fetch('/api/content/about').then(res => res.json()).then(data => setAboutData(data));
  }, []);
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setAboutData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview the image
      const reader = new FileReader();
      reader.onloadend = () => {
        setAboutData(prev => ({
          ...prev,
          imageUrl: reader.result
        }));
      };
      reader.readAsDataURL(file);
      
      // In a real app, you would upload this file to your server or cloud storage
      // uploadImage(file).then(url => setAboutData(prev => ({ ...prev, imageUrl: url })));
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    // Here you would send the updated data to your backend
    console.log("Saving about data:", aboutData);
    alert("Changes saved successfully!");
    
    // In a real app:
    // saveContentToBackend('/api/content/about', aboutData)
    //   .then(() => alert("Changes saved!"))
    //   .catch(err => alert("Error saving changes"));
  };
  
  return (
    <div className="section-editor">
      <h2>Edit About Section</h2>
      
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Section Title</label>
          <input 
            type="text" 
            name="title"
            value={aboutData.title}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label>Subtitle</label>
          <input 
            type="text" 
            name="subtitle"
            value={aboutData.subtitle}
            onChange={handleInputChange}
          />
        </div>
        
        <div className="form-group">
          <label>Main Content</label>
          <textarea
            name="mainContent"
            value={aboutData.mainContent}
            onChange={handleInputChange}
            rows="6"
          />
        </div>
        
        <div className="form-group">
          <label>Section Image</label>
          <div className="image-preview">
            <img src={aboutData.imageUrl} alt="About section" />
          </div>
          <input 
            type="file" 
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>
        
        <button type="submit" className="save-button">Save Changes</button>
      </form>
    </div>
  );
};

export default AboutEditor;